import { useAuth } from "@/contexts/use-auth";
import React from "react";
import { Navigate } from "react-router";
import Loader from "./Loader";
import NotAuthorized from "./UnAuthorized";

/** Roles that use API `canAccess*` flags on routes (managers). Everyone else keeps legacy role/permission checks. */
const PERMISSION_NAV_ROLES = new Set(["manager", "staff", "coordinator"]);

const DashboardWrapper = ({
  permission,
  children,
  canViewByRole,
  alsoAllowIfCanAccess,
}: {
  permission: any;
  children: React.ReactNode;
  canViewByRole?: string[];
  /** Manager/staff/coordinator only: allow route when `canAccess(alsoAllowIfCanAccess)` is true. */
  alsoAllowIfCanAccess?: string;
}) => {
  const { isAuthorized, user, isLoading, isAuthenticated, canAccess } = useAuth();
  if (isLoading) {
    return <Loader/>;
  }
  if (!isAuthenticated) {
    return <Navigate to={"/auth"} />;
  }
  let IS_AUTHORIZED = permission ? false : true;
  if (typeof permission === "string") {
    IS_AUTHORIZED = isAuthorized(permission);
  } else if (Array.isArray(permission)) {
    for (let i = 0; i < permission.length; i++) {
      if (!isAuthorized(permission[i])) {
        IS_AUTHORIZED = false;
        break;
      } else {
        IS_AUTHORIZED = true;
      }
    }
  }

  let isCanViewByRole = false;
  const userRole = (user?.role ?? "").trim().toLowerCase();
  if (canViewByRole?.length) {
    for (let i = 0; i < canViewByRole.length; i++) {
      if (userRole === String(canViewByRole[i]).trim().toLowerCase()) {
        isCanViewByRole = true;
        break;
      }
    }
  }

  const isPermissionNavRole = PERMISSION_NAV_ROLES.has(user?.role ?? "");

  const roleOrAccessOk =
    !canViewByRole?.length ||
    isCanViewByRole ||
    (isPermissionNavRole &&
      !!alsoAllowIfCanAccess &&
      canAccess(alsoAllowIfCanAccess));

  return IS_AUTHORIZED && roleOrAccessOk ? (
    children
  ) : (
    <NotAuthorized/>
  );
};

export default DashboardWrapper;
